import { render } from "./FrontDeskRightPanel.vue?vue&type=template&id=2f8fd670"
import script from "./FrontDeskRightPanel.vue?vue&type=script&lang=js"
export * from "./FrontDeskRightPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__